// The accent colour each user picks for light and dark mode (saved on their profile).
// The colours go on <html> as CSS variables; global.css turns them into the accent tokens
// of the mode that is showing.

export const ACCENT_PRESETS = ['#3fae4c', '#2f6fca', '#7c4dff', '#d63384', '#f26b2c', '#e0a100', '#0f9d9a', '#5f5e5a'];

/** A #rrggbb colour, or null. */
export function normalizeHex(v: string | undefined | null): string | null {
  const s = (v ?? '').trim().toLowerCase();
  return /^#[0-9a-f]{6}$/.test(s) ? s : null;
}

/** Dark text on a light colour and light text on a dark one. */
export function onColor(hex: string): string {
  const n = parseInt(hex.slice(1), 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((c) => {
    const x = c / 255;
    return x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
  });
  const lum = 0.2126 * r! + 0.7152 * g! + 0.0722 * b!;
  return lum > 0.4 ? '#111111' : '#ffffff';
}

export function applyAccents(light?: string | null, dark?: string | null) {
  const root = document.documentElement;
  for (const [mode, value] of [
    ['l', normalizeHex(light)],
    ['d', normalizeHex(dark)],
  ] as const) {
    if (value) {
      root.style.setProperty(`--ua-${mode}`, value);
      root.style.setProperty(`--ua-${mode}-on`, onColor(value));
      root.setAttribute(`data-accent-${mode}`, '');
    } else {
      root.style.removeProperty(`--ua-${mode}`);
      root.style.removeProperty(`--ua-${mode}-on`);
      root.removeAttribute(`data-accent-${mode}`);
    }
  }
}
